<template>
  <div v-if="!!block.data.title || !!block.data.message" class="wrapper w-mb2">
    <div class="warning">
      <div class="h4" v-if="!!block.data.title">{{ block.data.title }}</div>
      <p v-if="!!block.data.message">
        {{ block.data.message }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "WarningBlock",
  props: ["block"],
};
</script>
<style lang="scss" scoped>
@import "resources/sass/block-headings.scss";

.warning {
  position: relative;
  padding: 0.75rem 1.25rem;
  border: 1px solid #ffeeba;
  border-radius: 0.25rem;
  color: #856404;
  background-color: #fff3cd;

  @for $i from 1 through 6 {
    div.h#{$i} {
      margin-bottom: 0.5em;
    }
  }

  p {
    margin-bottom: 0;
    font-size: 1.2em;
    line-height: 1.3em;
  }
}
</style>
